import { email, type InferOutput } from "valibot";

// 'auth_login' input
export const authLoginSchema = v.object({
  username: v.string("Veuillez saisir votre identifiant"),
  password: v.string("Veuillez saisir votre mot de passe"),
  remember: v.optional(v.boolean()),
});
export type AuthLogin = InferOutput<typeof authLoginSchema>;

// 'auth_forgot_password' input
export const authForgotPasswordSchema = v.object({
  email: v.pipe(v.string("Veuillez saisir votre courriel"), email()),
});
export type AuthForgotPassword = InferOutput<typeof authForgotPasswordSchema>;

// 'auth_reset_password' input
export const authResetPasswordSchema = v.object({
  reset_key: v.string("Veuillez saisir votre clé de réinitialisation"),
  login: v.string("Veuillez saisir votre identifiant"),
  password: v.string("Veuillez saisir votre mot de passe"),
});
export type AuthResetPassword = InferOutput<typeof authResetPasswordSchema>;

// 'auth_register' input
export const authRegisterSchema = v.object({
  first_name: v.string("Veuillez saisir votre prénom"),
  last_name: v.string("Veuillez saisir votre nom"),
  display_name: v.string("Veuillez saisir votre nom d'affichage"),
  email: v.pipe(v.string("Veuillez saisir votre courriel"), email()),
  birthday: v.optional(v.date()),
});
export type AuthRegister = InferOutput<typeof authRegisterSchema>;
